import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Activity } from '@shared/models/activity';
import { environment } from '@environments/environment';
import { IdToIdsMappings } from '@features/associations/models/mappings';

// Endpoint root
const APIURL = environment.apiUrl;
type ActivitiesGetListType = 'frontend' | 'resource' | null;

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  private readonly http = inject(HttpClient);

  getList(type: ActivitiesGetListType = null, locationId?: number, expand?: boolean): Observable<Activity[]> {
    let params = '';

    if (type) {
      params += `?type=${type}`;
    }
    if (locationId) {
      params += `&location_id=${locationId}`;
    }
    if (expand) {
      params += '&expand=parent';
    }
    return this.http.get<Activity[]>(`${APIURL}/activities/${params}`);
  }

  get(id: number, expand: boolean): Observable<Activity> {
    let params = '';
    if (expand) {
      params += '?expand=parent';
    }
    return this.http.get<Activity>(`${APIURL}/activities/${id}/${params}`);
  }

  toTreeview(activities: Activity[]): Activity[] {
    const mapTree: Record<number, number> = {};
    const roots: Activity[] = [];
    let node: Activity = {} as Activity;
    let i = 0;

    for (i = 0; i < activities.length; i += 1) {
      mapTree[activities[i].id] = i;
      activities[i].children = [];
    }

    for (i = 0; i < activities.length; i += 1) {
      node = activities[i];

      if (node.parentId > 0) {
        activities[mapTree[node.parentId]]?.children.push(node);
      } else {
        roots.push(node);
      }
    }

    return roots;
  }

  locationsMapping(): Observable<IdToIdsMappings> {
    return this.http.get<IdToIdsMappings>(`${APIURL}/activities/locations-mapping`);
  }
}
